import { render } from "./DropdownButtonContainerProduction.vue.js?vue&type=template&id=0378fcac!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DropdownButtonContainerProduction.vue?vue&type=template&id=0378fcac"
import script from "./DropdownButtonContainerProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DropdownButtonContainerProduction.vue?vue&type=script&lang=js"
export * from "./DropdownButtonContainerProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DropdownButtonContainerProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/dropdown-button/DropdownButtonContainerProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0378fcac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0378fcac', __exports__)) {
    api.reload('0378fcac', __exports__)
  }
  
  module.hot.accept("./DropdownButtonContainerProduction.vue.js?vue&type=template&id=0378fcac!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DropdownButtonContainerProduction.vue?vue&type=template&id=0378fcac", () => {
    api.rerender('0378fcac', render)
  })

}


export default __exports__